import React from "react";
import { Alert, Box, IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";

/**
 * FL-312: the dismissible banner shown while an instructor previews
 * released results as a student — one look shared by Team Review and
 * Work Review.
 */
export function ResultsPreviewBanner({
  message,
  onClose,
}: {
  message: string;
  onClose: () => void;
}) {
  return (
    <Box sx={{ maxWidth: 800, mx: "auto", px: 3, pt: 2 }}>
      <Alert
        severity="info"
        action={
          <IconButton size="small" onClick={onClose} aria-label="Close preview">
            <Close fontSize="small" />
          </IconButton>
        }
      >
        {message}
      </Alert>
    </Box>
  );
}
